import { ISharingRootTraffic } from 'shared/atoms';

export const RootTrafficUtil = {
  getShareContentExtra: (traffic: ISharingRootTraffic) => {
    return {
      share_content_type: traffic.enterPageName,
      share_content_id: traffic.enterPageId || null,
    };
  },
};
